import { render } from "./PaginationPrevious.vue?vue&type=template&id=7da16740&ts=true"
import script from "./PaginationPrevious.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationPrevious.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/pagination/PaginationPrevious.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7da16740"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7da16740', __exports__)) {
    api.reload('7da16740', __exports__)
  }
  
  module.hot.accept("./PaginationPrevious.vue?vue&type=template&id=7da16740&ts=true", () => {
    api.rerender('7da16740', render)
  })

}


export default __exports__